"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = __importDefault(require("./cache"));
var file_1 = __importDefault(require("./file"));
exports.default = {
    listFiles: file_1.default.listFiles,
    getFileDetails: file_1.default.getDetails,
    updateFileDetails: file_1.default.updateDetails,
    getFileMetadata: file_1.default.getMetadata,
    deleteFile: file_1.default.deleteFile,
    bulkDeleteFiles: file_1.default.bulkDeleteFiles,
    bulkAddTags: file_1.default.bulkAddTags,
    bulkRemoveTags: file_1.default.bulkRemoveTags,
    copyFile: file_1.default.copyFile,
    moveFile: file_1.default.moveFile,
    copyFolder: file_1.default.copyFolder,
    moveFolder: file_1.default.moveFolder,
    createFolder: file_1.default.createFolder,
    deleteFolder: file_1.default.deleteFolder,
    getBulkJobStatus: file_1.default.getBulkJobStatus,
    purgeCache: cache_1.default.purgeCache,
    getPurgeCacheStatus: cache_1.default.getPurgeCacheStatus,
};
